export default (context) => {
    if(context.is_other_date) {
        context.$router.push('/calendar')
    } else {
        context.is_other_date = false
        context.error.status = false
        context.overlay = false
        context.loading = false
    }

}